/** 单据主键由已知业务路由取得；审批类型及付款批次仍由服务器枚举。 */
const contractPages = new Set([
  "confirmTradeContract", "confirmFastTradeContract", "confirmFastPurchaseContract",
  "fastTradeContractDetail", "fastPurchaseContractDetail", "confirmFastPurchasePayment",
  "fastPurchasePayment", "selectPaymentMethod", "uploadPaymentVoucher", "confirmFastTradeInvoice",
]);
const orderPages = new Set(["fastPurchaseContract", "fastTradeContract"]);
export function workflowBusinessForRoute(route = {}) {
  const page = String(route.path || "").split("/").pop();
  const query = route.query || {};
  if (orderPages.has(page)) {
    const saved = positiveScope("CONTRACT", query.id);
    if (saved) return saved;
    if (String(query.isDraft) === "1" && (query.goodsCode || /^[1-9]\d*$/.test(String(query.preOrderId || ""))))
      return { businessType: "CONTRACT_DRAFT", goodsCode: query.goodsCode, preOrderId: query.preOrderId };
    return null;
  }
  if (page === "outboundOrderAudit") {
    if (query.outboundId != null) return positiveScope("OUTBOUND", query.outboundId);
    // 出库单草稿没有单据ID，旧合同出货页才以id绑定合同流程。
    return query.id != null ? positiveScope("CONTRACT", query.id) : null;
  }
  return contractPages.has(page) ? positiveScope("CONTRACT", query.id) : null;
}
export function workflowReviewTypeForRoute(route = {}) {
  const page = String(route.path || "").split("/").pop();
  if (orderPages.has(page)) return 1;
  if (page === "outboundOrderAudit") return 6;
  if (page === "confirmFastTradeInvoice") return 5;
  if (page === "selectPaymentMethod") return 4;
  if (["confirmFastPurchasePayment", "fastPurchasePayment", "uploadPaymentVoucher"].includes(page)) return 3;
  return 2;
}
function positiveScope(businessType, value) {
  const id = String(value || "");
  return /^[1-9]\d*$/.test(id) ? { businessType, businessId: id } : null;
}
export const workflowScopeKey = (scope) => scope ? [scope.businessType, scope.businessId, scope.reviewType, scope.installmentNo].join(":") : "";
export function workflowScopeName(scope) {
  if (!scope) return "流程讨论";
  const labels = ["", "订单审批", "合同审批", "付款审批", "付款方式审批", "发票审批", "出库审批"];
  return (labels[scope.reviewType] || "流程讨论") + (Number(scope.installmentNo) > 0 ? ` · 第${scope.installmentNo}期` : "");
}
export function workflowMessageId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return `msg_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}
export function mergeWorkflowMessages(previous, incoming) {
  const entries = new Map(previous.map((message) => [message.sequence, message]));
  incoming.forEach((message) => entries.set(message.sequence, message));
  return [...entries.values()].sort((a, b) => a.sequence - b.sequence);
}
